"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RecommendedSpinsSlider;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _resize = _interopRequireDefault(require("@ux/icon/resize"));
var _reactMintl = require("@godaddy/react-mintl");
var _chevronLeft = _interopRequireDefault(require("@ux/icon/chevron-left"));
var _chevronRight = _interopRequireDefault(require("@ux/icon/chevron-right"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SpinCard = _interopRequireDefault(require("../SpinCard"));
var _uxUtils = require("@site/ux-utils");
var _button = _interopRequireDefault(require("@ux/button"));
var _RequestStatus = _interopRequireDefault(require("../constants/RequestStatus"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RecommendedSpinsSlider({
  spinsData,
  requestStatus,
  sliderHeader,
  sliderHeaderIcon,
  options = {},
  cardCount = 4,
  ctaProps,
  enableDynamicFontScaling,
  PriceBlock,
  language,
  AddToCartButton,
  sliderSettings = {},
  dataEid,
  isCountdownTimerEnabled = false
}) {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  let sliderRef = (0, _react.useRef)(null);
  const {
    showFreeIndicator,
    maxSpins = 40
  } = options;
  const domains = (0, _utils.transformSpinData)({
    findResponse: spinsData,
    showFreeIndicator,
    maxSpins,
    isCountdownTimerEnabled
  });
  const renderSlider = requestStatus === _RequestStatus.default.LOADING || domains.length > cardCount;
  const handleNext = () => {
    sliderRef.slickNext();
  };
  const handlePrev = () => {
    sliderRef.slickPrev();
  };
  const settings = {
    dots: false,
    infinite: true,
    centerMode: false,
    speed: 1000,
    slidesToShow: cardCount,
    slidesToScroll: cardCount,
    arrows: false,
    draggable: false,
    ...sliderSettings
  };
  const cards = (requestStatus === _RequestStatus.default.LOADING ? new Array(cardCount).fill() : domains).map(domain => {
    const product = domain?.product;
    return /*#__PURE__*/_react.default.createElement(_SpinCard.default, {
      key: domain?.Fqdn,
      domain: domain,
      product: product,
      ctaProps: ctaProps,
      options: options,
      enableDynamicFontScaling: enableDynamicFontScaling,
      PriceBlock: PriceBlock,
      language: language,
      AddToCartButton: AddToCartButton,
      customClassName: "h-100",
      hideIcon: true,
      dataEid: dataEid
    });
  });
  if (requestStatus !== _RequestStatus.default.LOADING && !domains.length) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-recommended-slider"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "recommended-spins-slider",
    "data-testid": "recommended-spins-slider",
    className: "recommended-spins-slider p-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between p-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, sliderHeaderIcon ? sliderHeaderIcon : /*#__PURE__*/_react.default.createElement(_resize.default, {
    className: "mr-2"
  }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    className: "ms3",
    id: sliderHeader
  })), domains?.length > cardCount && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
    icon: /*#__PURE__*/_react.default.createElement(_chevronLeft.default, null),
    className: "bg-transparent text-black p-0 mr-2",
    onClick: handlePrev,
    "data-testid": "prev-page-button"
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    icon: /*#__PURE__*/_react.default.createElement(_chevronRight.default, null),
    className: "bg-transparent text-black p-0 ml-2",
    onClick: handleNext,
    "data-testid": "next-page-button"
  }))), renderSlider ? /*#__PURE__*/_react.default.createElement(_reactSlick.default, (0, _extends2.default)({}, settings, {
    ref: slider => {
      sliderRef = slider;
    }
  }), cards) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('spins-cards-container', {
      'd-grid': !isMobile
    })
  }, cards)));
}